import { jsxs as p, jsx as n, Fragment as q } from "react/jsx-runtime";
import { useRef as C, useEffect as P, useCallback as _, useState as X } from "react";
import { createPortal as K } from "react-dom";
const z = {
  background: "var(--xp-close-red)",
  border: "none",
  padding: 0,
  cursor: "pointer"
}, H = {
  display: "block",
  width: 8,
  height: 1.5,
  background: "#FFF",
  marginTop: 8
}, W = {
  display: "block",
  width: 9,
  height: 9,
  border: "1.5px solid #FFF",
  borderTopWidth: 2
}, Q = {
  position: "absolute",
  top: 0,
  right: 0,
  width: 7,
  height: 7,
  border: "1.5px solid #FFFFFF"
}, J = {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: 7,
  height: 7,
  border: "1.5px solid #FFFFFF",
  background: "var(--xp-titlebar-flat)"
}, ee = {
  position: "relative",
  display: "inline-block",
  width: 10,
  height: 10
};
function Ce({
  title: e,
  icon: t,
  children: r,
  className: a = "",
  maxWidth: o = "800px",
  onClose: s,
  titleBarRef: d,
  onMinimize: i,
  onMaximize: u,
  isMaximized: f = !1
}) {
  const h = a ? `xp-window ${a}` : "xp-window", g = !!i || !!u, k = /* @__PURE__ */ n("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", "aria-hidden": "true", children: /* @__PURE__ */ n(
    "path",
    {
      d: "M1 1L9 9M9 1L1 9",
      stroke: "white",
      strokeWidth: "1.6",
      strokeLinecap: "round"
    }
  ) });
  return /* @__PURE__ */ p("div", { className: h, style: { maxWidth: o }, children: [
    /* @__PURE__ */ p("div", { className: "xp-window__titlebar", ref: d, children: [
      /* @__PURE__ */ p("div", { className: "xp-window__title", children: [
        t && /* @__PURE__ */ n(
          "img",
          {
            src: t,
            alt: "",
            className: "xp-window__icon"
          }
        ),
        /* @__PURE__ */ n("span", { className: "xp-heading xp-window__title-text", children: e })
      ] }),
      /* @__PURE__ */ p(
        "div",
        {
          className: "xp-window__controls",
          role: g ? void 0 : "presentation",
          children: [
            i ? /* @__PURE__ */ n(
              "button",
              {
                type: "button",
                "aria-label": "Minimize window",
                onClick: i,
                className: "xp-window__control xp-window__control--interactive",
                children: /* @__PURE__ */ n("span", { style: H })
              }
            ) : /* @__PURE__ */ n("span", { "aria-hidden": "true", className: "xp-window__control", children: /* @__PURE__ */ n("span", { style: H }) }),
            u ? /* @__PURE__ */ n(
              "button",
              {
                type: "button",
                "aria-label": f ? "Restore window" : "Maximize window",
                onClick: u,
                className: "xp-window__control xp-window__control--interactive",
                children: f ? /* @__PURE__ */ p("span", { style: ee, children: [
                  /* @__PURE__ */ n("span", { style: Q }),
                  /* @__PURE__ */ n("span", { style: J })
                ] }) : /* @__PURE__ */ n("span", { style: W })
              }
            ) : /* @__PURE__ */ n("span", { "aria-hidden": "true", className: "xp-window__control", children: /* @__PURE__ */ n("span", { style: W }) }),
            s ? /* @__PURE__ */ n(
              "button",
              {
                type: "button",
                "aria-label": "Close window",
                onClick: s,
                className: "xp-window__control xp-window__control--close",
                style: z,
                onMouseEnter: (m) => {
                  m.currentTarget.style.background = "var(--xp-close-red-hover)";
                },
                onMouseLeave: (m) => {
                  m.currentTarget.style.background = "var(--xp-close-red)";
                },
                onMouseDown: (m) => {
                  m.currentTarget.style.background = "var(--xp-close-red-active)";
                },
                onMouseUp: (m) => {
                  m.currentTarget.style.background = "var(--xp-close-red-hover)";
                },
                children: k
              }
            ) : /* @__PURE__ */ n("span", { "aria-hidden": "true", className: "xp-window__control xp-window__control--close", children: k })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ n("div", { className: "xp-window__body", children: r })
  ] });
}
function te(e, t, r) {
  const a = e === "default" ? "" : ` btn-card--${e}`, o = t === "md" ? "" : ` btn-card--${t}`;
  return `btn-card${a}${o}${r ? " " + r : ""}`;
}
function Te(e) {
  const {
    variant: t = "default",
    size: r = "md",
    iconLeft: a,
    iconRight: o,
    className: s = "",
    children: d
  } = e, i = te(t, r, s), u = /* @__PURE__ */ p(q, { children: [
    a ? /* @__PURE__ */ n("span", { "aria-hidden": "true", className: "btn-card__icon", children: a }) : null,
    /* @__PURE__ */ n("span", { className: "btn-card__label", children: d }),
    o ? /* @__PURE__ */ n("span", { "aria-hidden": "true", className: "btn-card__icon", children: o }) : null
  ] });
  if ("href" in e && e.href !== void 0) {
    const { href: y, external: T, variant: N, size: F, iconLeft: I, iconRight: D, className: B, children: O, ...S } = e, $ = T ? "noopener noreferrer" : S.rel, R = T ? "_blank" : S.target;
    return /* @__PURE__ */ n("a", { ...S, href: y, target: R, rel: $, className: i, children: u });
  }
  const { variant: f, size: h, iconLeft: g, iconRight: k, className: m, children: v, ...E } = e;
  return /* @__PURE__ */ n("button", { type: E.type ?? "button", ...E, className: i, children: u });
}
function Ie({ children: e, variant: t = "blue", className: r = "" }) {
  const a = `xp-pill xp-pill--${t} xp-heading${r ? " " + r : ""}`;
  return /* @__PURE__ */ n("span", { className: a, children: e });
}
const re = { sm: 8, md: 10, lg: 12 }, ne = {
  live: "var(--sw4p-status-live)",
  building: "var(--sw4p-status-building)",
  horizon: "var(--sw4p-status-warning)",
  inactive: "var(--sw4p-text-muted)"
}, ae = {
  live: "ledPulseLive 2s ease-in-out infinite",
  building: void 0,
  horizon: "ledIdle 3s ease-in-out infinite",
  inactive: void 0
}, U = {
  display: "inline-block",
  flexShrink: 0
};
function oe({
  tone: e,
  size: t = "md",
  className: r = "",
  variant: a = "dot"
}) {
  if (a === "sweep" || e === "building") {
    const u = {
      ...U,
      width: t === "sm" ? 10 : t === "lg" ? 14 : 12,
      height: t === "sm" ? 5 : t === "lg" ? 7 : 6,
      background: "linear-gradient(90deg, #0a2e7a 0%, #5391f8 50%, #0a2e7a 100%)",
      backgroundSize: "200% 100%",
      animation: "ledSweep 1.8s linear infinite",
      borderRadius: 1
    };
    return /* @__PURE__ */ n("span", { "aria-hidden": "true", className: r, style: u });
  }
  const o = re[t], s = {
    ...U,
    width: o,
    height: o,
    backgroundColor: ne[e],
    boxShadow: e === "horizon" ? "0 0 0 1px var(--sw4p-status-warning), 0 0 0 2px rgba(255, 255, 255, 0.35)" : "0 0 0 1px rgba(255, 255, 255, 0.45)",
    animation: ae[e],
    borderRadius: "50%"
  };
  return /* @__PURE__ */ n("span", { "aria-hidden": "true", className: r, style: s });
}
function Ae({ value: e, label: t }) {
  return /* @__PURE__ */ p("div", { className: "xp-stat-box", children: [
    /* @__PURE__ */ n("span", { className: "xp-stat-box__value xp-heading", children: e }),
    /* @__PURE__ */ n("span", { className: "xp-stat-box__label", children: t })
  ] });
}
const se = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
function Fe({
  open: e,
  onClose: t,
  side: r = "right",
  children: a,
  title: o,
  ariaLabel: s,
  showHeader: d = !1,
  closeLabel: i = "Close",
  backdropClassName: u,
  panelClassName: f,
  initialFocusRef: h,
  returnFocusRef: g,
  portal: k = !0,
  container: m
}) {
  const v = C(null), E = C(null), y = C(t);
  y.current = t, P(() => {
    if (!e) return;
    E.current = ((g == null ? void 0 : g.current) ?? null) || (document.activeElement instanceof HTMLElement ? document.activeElement : null);
    const l = v.current, c = (h == null ? void 0 : h.current) ?? l ?? null, w = requestAnimationFrame(() => c == null ? void 0 : c.focus()), x = () => Array.from(
      (l == null ? void 0 : l.querySelectorAll(se)) ?? []
    ).filter(
      (b) => b.getAttribute("aria-hidden") !== "true" && !b.hasAttribute("hidden")
    ), L = (b) => {
      if (b.key === "Escape") {
        b.stopPropagation(), y.current();
        return;
      }
      if (b.key !== "Tab") return;
      const A = x();
      if (A.length === 0) {
        b.preventDefault(), l == null || l.focus();
        return;
      }
      const j = A[0], G = A[A.length - 1], M = document.activeElement;
      b.shiftKey ? (M === j || M === l) && (b.preventDefault(), G.focus()) : M === G && (b.preventDefault(), j.focus());
    };
    return document.addEventListener("keydown", L), () => {
      var b;
      cancelAnimationFrame(w), document.removeEventListener("keydown", L), (b = E.current) == null || b.focus();
    };
  }, [e]);
  const T = _(() => {
    y.current();
  }, []), N = C(null), F = _(() => {
    var c;
    const l = (c = v.current) == null ? void 0 : c.querySelector(".sw4p-drawer__grab");
    return !!l && getComputedStyle(l).display !== "none";
  }, []), I = _((l) => {
    const c = v.current, w = N.current;
    if (N.current = null, !c) return;
    const x = Math.max(88, c.getBoundingClientRect().height * 0.22);
    if (l && w && w.dy > x) {
      y.current();
      return;
    }
    c.style.transition = "transform 160ms var(--sw4p-ease-out, ease-out)", c.style.transform = "translateY(0)", window.setTimeout(() => {
      v.current === c && (c.style.transition = "", c.style.transform = "");
    }, 200);
  }, []), D = _(
    (l) => {
      var w, x;
      if (!F()) return;
      const c = v.current;
      c && (N.current = { startY: l.clientY, dy: 0, pointerId: l.pointerId }, c.style.transition = "none", (x = (w = l.currentTarget).setPointerCapture) == null || x.call(w, l.pointerId));
    },
    [F]
  ), B = _((l) => {
    const c = N.current, w = v.current;
    if (!c || !w || l.pointerId !== c.pointerId) return;
    const x = l.clientY - c.startY, L = x > 0 ? x : x / 4;
    c.dy = Math.max(0, L), w.style.transform = `translateY(${Math.max(0, L)}px)`;
  }, []), O = _(
    (l) => {
      const c = N.current;
      !c || l.pointerId !== c.pointerId || I(!0);
    },
    [I]
  );
  if (!e) return null;
  const S = s ?? (typeof o == "string" ? o : void 0), $ = ["sw4p-drawer-backdrop", `sw4p-drawer-backdrop--${r}`, u].filter(Boolean).join(" "), R = ["sw4p-drawer", `sw4p-drawer--${r}`, f].filter(Boolean).join(" "), Y = /* @__PURE__ */ n("div", { className: $, role: "presentation", onMouseDown: T, children: /* @__PURE__ */ p(
    "div",
    {
      ref: v,
      className: R,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": S,
      tabIndex: -1,
      onMouseDown: (l) => l.stopPropagation(),
      children: [
        /* @__PURE__ */ n(
          "div",
          {
            className: "sw4p-drawer__grab",
            "aria-hidden": "true",
            onPointerDown: D,
            onPointerMove: B,
            onPointerUp: O,
            onPointerCancel: () => I(!1)
          }
        ),
        d && /* @__PURE__ */ p("div", { className: "sw4p-drawer__header", children: [
          o != null && /* @__PURE__ */ n("div", { className: "sw4p-drawer__title", children: o }),
          /* @__PURE__ */ n(
            "button",
            {
              type: "button",
              className: "sw4p-drawer__close",
              onClick: () => y.current(),
              "aria-label": i,
              children: /* @__PURE__ */ n(
                "svg",
                {
                  "aria-hidden": "true",
                  viewBox: "0 0 12 12",
                  className: "sw4p-drawer__close-icon",
                  focusable: "false",
                  children: /* @__PURE__ */ n(
                    "path",
                    {
                      d: "M3 3 9 9M9 3 3 9",
                      fill: "none",
                      stroke: "currentColor",
                      strokeLinecap: "round",
                      strokeWidth: "1.75"
                    }
                  )
                }
              )
            }
          )
        ] }),
        a
      ]
    }
  ) });
  return !k || typeof document > "u" ? Y : K(Y, m ?? document.body);
}
function $e({
  src: e = "https://cdn.sw4p.io/sw4p/brand/logo-transparent.png",
  size: t = 24,
  alt: r = "SW4P",
  style: a,
  ...o
}) {
  const s = typeof t == "number" ? `${t}px` : t;
  return /* @__PURE__ */ n(
    "img",
    {
      src: e,
      alt: r,
      width: typeof t == "number" ? t : void 0,
      height: typeof t == "number" ? t : void 0,
      style: {
        width: s,
        height: s,
        objectFit: "contain",
        display: "inline-block",
        ...a
      },
      ...o
    }
  );
}
const ie = { sm: 20, md: 24, lg: 28 }, le = {
  square: 0.58,
  landscape: 0.66,
  circular: 0.78,
  glyph: 0.55
}, ce = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  borderRadius: "50%",
  overflow: "hidden",
  // 2px matches the XP-grammar chrome weight that the pre-migration
  // <img className='border-2'> in WaaSWallet used. A 1px border was
  // nearly invisible on dark tints (notably TOKEN_555_CHIP_TINT's
  // near-black bg) and made the 555 chip read as borderless next to
  // surrounding white-frame chips. See the SwapCard redesign spec and
  // code-review finding #15 on the 555-logo-sweep PR.
  borderWidth: 2,
  borderStyle: "solid"
};
function Re({
  src: e,
  glyph: t,
  bboxClass: r,
  size: a = "md",
  chipTint: o,
  glyphTint: s,
  className: d
}) {
  const i = typeof a == "number" ? a : ie[a], u = Math.round(i * le[r]), f = o ?? s, h = !!f, g = {
    ...ce,
    width: i,
    height: i,
    background: h ? f.bg : "#FFFFFF",
    borderColor: h ? f.border : "var(--xp-border-card)"
  };
  return /* @__PURE__ */ n("span", { "aria-hidden": "true", className: d, style: g, children: t ? /* @__PURE__ */ n(
    "span",
    {
      style: {
        fontSize: u,
        color: h ? f.fg ?? "#FFFFFF" : "#333333",
        fontFamily: '"Trebuchet MS", "Tahoma", system-ui, sans-serif',
        fontWeight: 700,
        lineHeight: 1
      },
      children: t
    }
  ) : e ? /* @__PURE__ */ n(
    "img",
    {
      src: e,
      alt: "",
      style: {
        width: u,
        height: u,
        objectFit: "contain",
        display: "block"
      }
    }
  ) : null });
}
function Me({
  children: e,
  header: t,
  headerTone: r = "muted",
  className: a,
  headerClassName: o,
  as: s = "div",
  style: d
}) {
  const i = `xp-feature-card${a ? " " + a : ""}`, u = `xp-feature-card__header xp-feature-card__header--${r}${o ? " " + o : ""}`;
  return /* @__PURE__ */ p(s, { className: i, style: d, children: [
    t !== void 0 ? /* @__PURE__ */ n("div", { className: u, children: t }) : null,
    e
  ] });
}
const Pe = ({
  className: e = "",
  hasError: t,
  ...r
}) => /* @__PURE__ */ n(
  "input",
  {
    className: `
        bg-white
        px-2
        outline-none
        font-['Tahoma']
        rounded-[3px]
        focus:border-[var(--xp-titlebar-flat)]
        ${t ? "border-red-500 bg-red-50" : ""}
        ${e}
      `,
    style: {
      border: t ? void 0 : "1px solid var(--xp-border-card)"
    },
    ...r
  }
), De = ({
  className: e = "",
  children: t,
  ...r
}) => /* @__PURE__ */ n(
  "select",
  {
    className: `
        bg-white
        px-1
        outline-none
        font-['Tahoma']
        rounded-[3px]
        focus:border-[var(--xp-titlebar-flat)]
        ${e}
      `,
    style: { border: "1px solid var(--xp-border-card)" },
    ...r,
    children: t
  }
);
function Be({ className: e = "", hasError: t, ...r }) {
  const a = t ? " xp-input-box--error" : "", o = e ? " " + e : "";
  return /* @__PURE__ */ n("input", { className: `xp-input-box${a}${o}`, ...r });
}
function Oe({
  statusIndicator: e,
  iconNode: t,
  heading: r,
  subheading: a,
  onOverflow: o,
  overflowAriaLabel: s,
  body: d,
  actions: i,
  className: u = ""
}) {
  const f = "border-b border-sw4p-faint last:border-b-0 px-4 py-3 hover:bg-sw4p-surface-2 motion-safe:transition-colors motion-safe:duration-fast" + (u ? ` ${u}` : "");
  return /* @__PURE__ */ p("article", { className: f, children: [
    /* @__PURE__ */ p("header", { className: "flex items-start justify-between gap-3", children: [
      /* @__PURE__ */ p("div", { className: "flex items-center gap-2 min-w-0 flex-1", children: [
        e,
        t,
        /* @__PURE__ */ p("div", { className: "min-w-0", children: [
          /* @__PURE__ */ n("p", { className: "m-0 text-body font-bold text-sw4p truncate", children: r }),
          a && /* @__PURE__ */ n("p", { className: "m-0 text-meta text-sw4p-muted", children: a })
        ] })
      ] }),
      o && /* @__PURE__ */ n(
        "button",
        {
          type: "button",
          onClick: o,
          "aria-label": s,
          className: "inline-flex items-center justify-center w-7 h-7 rounded-md text-sw4p-muted hover:bg-sw4p-action-subtle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sw4p-action flex-shrink-0 motion-safe:active:scale-press-subtle motion-safe:transition-[transform,background-color] motion-safe:duration-fast",
          children: /* @__PURE__ */ p("svg", { width: "14", height: "14", viewBox: "0 0 14 14", "aria-hidden": "true", children: [
            /* @__PURE__ */ n("circle", { cx: "3", cy: "7", r: "1.2", fill: "currentColor" }),
            /* @__PURE__ */ n("circle", { cx: "7", cy: "7", r: "1.2", fill: "currentColor" }),
            /* @__PURE__ */ n("circle", { cx: "11", cy: "7", r: "1.2", fill: "currentColor" })
          ] })
        }
      )
    ] }),
    d && /* @__PURE__ */ n("div", { className: "mt-3", children: d }),
    i && /* @__PURE__ */ n("div", { className: "mt-3 flex flex-wrap justify-end gap-2", children: i })
  ] });
}
function Ye({ className: e = "", ariaLabel: t = "Loading" }) {
  return /* @__PURE__ */ p(
    "span",
    {
      role: "status",
      "aria-label": t,
      className: `inline-flex items-center gap-0.5 ${e}`,
      children: [
        /* @__PURE__ */ n("span", { "aria-hidden": "true", className: "w-1 h-1 rounded-full bg-current motion-safe:animate-pulse" }),
        /* @__PURE__ */ n("span", { "aria-hidden": "true", className: "w-1 h-1 rounded-full bg-current motion-safe:animate-pulse [animation-delay:120ms]" }),
        /* @__PURE__ */ n("span", { "aria-hidden": "true", className: "w-1 h-1 rounded-full bg-current motion-safe:animate-pulse [animation-delay:240ms]" })
      ]
    }
  );
}
const de = {
  primary: "bg-sw4p-action text-sw4p-surface-1 border border-sw4p-action hover:bg-sw4p-action-hover",
  ghost: "bg-transparent text-sw4p border border-sw4p-faint hover:border-sw4p-action",
  danger: "bg-transparent text-sw4p-status-error border border-sw4p-status-error hover:bg-sw4p-status-error-10"
}, ue = "bg-sw4p-faint text-sw4p-surface-1 border border-sw4p-faint cursor-not-allowed", pe = "bg-transparent text-sw4p-faint border border-sw4p-faint cursor-not-allowed", be = {
  sm: "h-7 px-3 text-meta",
  md: "h-9 px-4 text-body",
  lg: "h-11 px-5 text-heading"
}, fe = "inline-flex items-center justify-center gap-2 rounded-md font-bold no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sw4p-action focus-visible:ring-offset-1 motion-safe:active:scale-press-primary motion-safe:transition-[transform,background-color,border-color] motion-safe:duration-fast motion-safe:ease-sw4p-out";
function je({
  variant: e = "primary",
  size: t = "md",
  loading: r = !1,
  disabled: a,
  children: o,
  className: s = "",
  ...d
}) {
  const i = a || r, u = i ? e === "primary" ? ue : pe : de[e];
  return /* @__PURE__ */ n(
    "button",
    {
      type: "button",
      disabled: i,
      className: `${fe} ${be[t]} ${u} ${s}`,
      ...d,
      children: r ? /* @__PURE__ */ n(
        "span",
        {
          "aria-label": "Loading",
          role: "status",
          className: "inline-block w-4 h-4 rounded-full border-2 border-current border-t-transparent motion-safe:animate-spin"
        }
      ) : o
    }
  );
}
const he = {
  hero: "bg-sw4p-surface-1 p-5 sm:p-6",
  card: "bg-sw4p-surface-1 border border-sw4p-faint rounded-lg shadow-sm",
  data: "bg-sw4p-surface-1 border border-sw4p-faint rounded-lg",
  secondary: "p-3 sm:p-4"
}, me = {
  hero: "text-display font-bold text-sw4p-strong",
  card: "text-heading font-bold text-sw4p-strong",
  data: "text-heading font-bold text-sw4p-strong",
  secondary: "text-meta uppercase tracking-wider text-sw4p-muted"
}, we = {
  hero: "pb-3",
  card: "px-4 py-3 border-b border-sw4p-faint",
  data: "px-4 py-2.5 border-b border-sw4p-faint",
  secondary: "pb-2"
};
function Ge({
  variant: e = "card",
  title: t,
  action: r,
  headingLevel: a = 2,
  className: o = "",
  children: s,
  divided: d
}) {
  if (d)
    return /* @__PURE__ */ n("section", { className: `xp-section-card xp-section-card--divided${o ? " " + o : ""}`, children: s });
  const i = `h${a}`;
  return /* @__PURE__ */ p("section", { className: `${he[e]} ${o}`, children: [
    (t || r) && /* @__PURE__ */ p("header", { className: `flex flex-wrap items-center justify-between gap-2 ${we[e]}`, children: [
      t && /* @__PURE__ */ n(i, { className: `${me[e]} min-w-0`, children: t }),
      r && /* @__PURE__ */ n("div", { className: "flex items-center gap-2 flex-wrap min-w-0", children: r })
    ] }),
    /* @__PURE__ */ n("div", { children: s })
  ] });
}
const xe = {
  // Theme-aware: bg is a 12% tint of the status token; fg mixes the status token
  // with --sw4p-text-primary so it stays legible (darkened in light, lightened in
  // dark) instead of the old fixed light-theme hex that did not flip.
  active: { led: "live", bg: "color-mix(in oklab, var(--sw4p-status-live) 12%, transparent)", fg: "color-mix(in oklab, var(--sw4p-status-live) 55%, var(--sw4p-text-primary))", defaultLabel: "ACTIVE" },
  executing: { led: "building", bg: "color-mix(in oklab, var(--sw4p-status-building) 12%, transparent)", fg: "color-mix(in oklab, var(--sw4p-status-building) 55%, var(--sw4p-text-primary))", defaultLabel: "EXECUTING" },
  completed: { led: "live", bg: "color-mix(in oklab, var(--sw4p-status-live) 12%, transparent)", fg: "color-mix(in oklab, var(--sw4p-status-live) 55%, var(--sw4p-text-primary))", defaultLabel: "COMPLETED" },
  expired: { led: "horizon", bg: "color-mix(in oklab, var(--sw4p-status-warning) 12%, transparent)", fg: "color-mix(in oklab, var(--sw4p-status-warning) 55%, var(--sw4p-text-primary))", defaultLabel: "EXPIRED" },
  cancelled: { led: "inactive", bg: "color-mix(in oklab, var(--sw4p-text-muted) 12%, transparent)", fg: "var(--sw4p-text-muted)", defaultLabel: "CANCELLED" },
  paused: { led: "horizon", bg: "color-mix(in oklab, var(--sw4p-status-warning) 12%, transparent)", fg: "color-mix(in oklab, var(--sw4p-status-warning) 55%, var(--sw4p-text-primary))", defaultLabel: "PAUSED" },
  reconciliation: { led: "inactive", bg: "color-mix(in oklab, var(--sw4p-status-error) 12%, transparent)", fg: "color-mix(in oklab, var(--sw4p-status-error) 55%, var(--sw4p-text-primary))", defaultLabel: "REQUIRES RECONCILIATION" }
};
function He({ tone: e, label: t }) {
  const r = xe[e], a = e === "reconciliation";
  return /* @__PURE__ */ p(
    "span",
    {
      role: "status",
      "aria-live": e === "reconciliation" ? "assertive" : "polite",
      className: "inline-flex shrink-0 items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider whitespace-nowrap",
      style: { backgroundColor: r.bg, color: r.fg },
      children: [
        /* @__PURE__ */ n(
          oe,
          {
            tone: a ? "inactive" : r.led,
            size: "sm",
            variant: "dot"
          }
        ),
        t ?? r.defaultLabel
      ]
    }
  );
}
const ge = {
  fixed: "xp-taskbar--fixed",
  absolute: "xp-taskbar--absolute"
};
function We({
  start: e,
  items: t,
  tray: r,
  position: a = "fixed",
  className: o = "",
  style: s
}) {
  const d = ge[a], i = o ? `xp-taskbar ${d} xp-heading ${o}` : `xp-taskbar ${d} xp-heading`;
  return /* @__PURE__ */ p("div", { className: i, style: s, children: [
    e,
    t,
    r
  ] });
}
function Ue({
  children: e,
  ariaLabel: t,
  className: r = "",
  style: a
}) {
  const o = r ? `xp-taskbar__items ${r}` : "xp-taskbar__items";
  return /* @__PURE__ */ n(
    "nav",
    {
      className: o,
      role: "navigation",
      "aria-label": t,
      style: a,
      children: e
    }
  );
}
const ve = () => {
  const e = C(/* @__PURE__ */ new Map());
  return { play: _((r) => {
    let a = e.current.get(r);
    a || (a = new Audio(`/sounds/${r}.mp3`), a.volume = 0.3, e.current.set(r, a)), a.currentTime = 0, a.play().catch(() => {
    });
  }, []) };
}, ye = "/xp-icons/Information.png", Ve = ({
  message: e,
  title: t = "Notification",
  icon: r = ye,
  duration: a = 5e3,
  onClose: o
}) => {
  const [s, d] = X(!1), { play: i } = ve();
  return P(() => {
    d(!0), i("notify");
    const u = setTimeout(() => {
      d(!1), setTimeout(o, 300);
    }, a);
    return () => clearTimeout(u);
  }, [a, o, i]), /* @__PURE__ */ p(
    "div",
    {
      className: `
        w-[280px]
        transition-all duration-300 ease-in-out
        ${s ? "opacity-100" : "opacity-0"}
      `,
      style: {
        background: "var(--xp-toast-bg)",
        border: "1px solid var(--xp-border-frame)",
        borderRadius: "4px",
        boxShadow: "var(--xp-shadow-toast)"
      },
      children: [
        /* @__PURE__ */ p("div", { className: "flex justify-between items-center p-1 pr-2", children: [
          /* @__PURE__ */ n("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ n("div", { className: "font-bold text-[var(--xp-text-dark)] text-xs", children: t }) }),
          /* @__PURE__ */ n(
            "button",
            {
              onClick: () => {
                d(!1), setTimeout(o, 300);
              },
              "aria-label": "Close Notification",
              className: "w-4 h-4 flex items-center justify-center hover:bg-[var(--xp-close-red-hover)] rounded-sm",
              children: /* @__PURE__ */ n("svg", { width: "8", height: "8", viewBox: "0 0 10 10", children: /* @__PURE__ */ n("path", { d: "M1 1L9 9M9 1L1 9", stroke: "#666", strokeWidth: "1.5" }) })
            }
          )
        ] }),
        /* @__PURE__ */ p("div", { className: "flex p-2 pt-0 gap-3 items-start", children: [
          r && /* @__PURE__ */ n("img", { src: r, className: "w-8 h-8 object-contain", alt: "" }),
          /* @__PURE__ */ n("div", { className: "text-[11px] text-[var(--xp-text-dark)] leading-snug pt-1", children: e })
        ] })
      ]
    }
  );
};
function Z(e, t) {
  if (e) {
    if (typeof e == "string" || typeof e == "number") {
      t.push(String(e));
      return;
    }
    if (Array.isArray(e)) {
      e.forEach((r) => Z(r, t));
      return;
    }
    Object.entries(e).forEach(([r, a]) => {
      a && t.push(r);
    });
  }
}
function _e(...e) {
  const t = [];
  return e.forEach((r) => Z(r, t)), t.join(" ");
}
const Ne = {
  default: "sw4p-base-button--default",
  primary: "sw4p-base-button--primary",
  ghost: "sw4p-base-button--ghost",
  selector: "sw4p-base-button--selector",
  "menu-item": "sw4p-base-button--menu-item"
}, ke = {
  sm: "sw4p-base-button--sm",
  md: "sw4p-base-button--md",
  lg: "sw4p-base-button--lg"
};
function Xe({
  variant: e = "default",
  size: t = "md",
  className: r,
  type: a = "button",
  children: o,
  ...s
}) {
  return /* @__PURE__ */ n(
    "button",
    {
      ...s,
      type: a,
      "data-slot": "button",
      className: _e("sw4p-base-button", Ne[e], ke[t], r),
      children: o
    }
  );
}
const V = () => {
  if (typeof window > "u")
    return {
      screenWidth: 1024,
      screenHeight: 768,
      isMobile: !1,
      isTablet: !1
    };
  const e = window.visualViewport, t = Math.round((e == null ? void 0 : e.width) ?? window.innerWidth), r = Math.round((e == null ? void 0 : e.height) ?? window.innerHeight);
  return {
    screenWidth: t,
    screenHeight: r,
    isMobile: t < 640,
    isTablet: t >= 640 && t < 1024
  };
}, Ze = () => {
  const [e, t] = X(V);
  return P(() => {
    const r = () => {
      t(V());
    };
    r(), window.addEventListener("resize", r);
    const a = window.visualViewport;
    return a == null || a.addEventListener("resize", r), () => {
      window.removeEventListener("resize", r), a == null || a.removeEventListener("resize", r);
    };
  }, []), { ...e, isDesktop: !e.isMobile && !e.isTablet };
};
export {
  Xe as BaseButton,
  Te as ButtonCard,
  Re as CoinChip,
  Fe as Drawer,
  Me as FeatureCard,
  Pe as FormInput,
  De as FormSelect,
  Be as InputBox,
  Oe as ListRowCard,
  Ye as LoadingDots,
  Ie as Pill,
  je as PrimaryButton,
  Ge as SectionCard,
  Ae as StatBox,
  oe as StatusLed,
  He as StatusPill,
  $e as Sw4pLogo,
  We as Taskbar,
  Ue as TaskbarItemStrip,
  Ce as WindowFrame,
  Ve as XPToast,
  Ze as useResponsive,
  ve as useSounds
};
//# sourceMappingURL=index.js.map
